<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="user-reset-password content-wrapper">
      <div class="page-header">{{ $t('resetPassword') }}</div>
      <div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/user' }">{{ $t('user') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('resetPassword') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="width: 600px; margin-top: 30px;">
        <el-form ref="ruleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              {{ $t('username') }}
            </el-col>
            <el-col :span="12">
              {{ $t('email') }}
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-input :placeholder="$t('username')" v-model="user.username" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-input :placeholder="$t('email')" v-model="user.email" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              {{ $t('newPassword') }}
            </el-col>
          </el-row>

          <!--<el-row :gutter="20" style="padding: 12px 0 5px 0">-->
            <!--<el-col :span="24">-->
              <!--<el-radio v-model="isRandomPassword" label="1">-->
                <!--{{ $t('generatePassword') }}-->
              <!--</el-radio>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <!--<el-row :gutter="20" style="padding: 0 0 10px 0">-->
            <!--<el-col :span="24">-->
              <!--<el-radio v-model="isRandomPassword" label="0">-->
                <!--{{ $t('manualPassword') }}-->
              <!--</el-radio>-->
            <!--</el-col>-->
          <!--</el-row>-->

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-input :placeholder="$t('newPassword')" v-model="newPassword" type="password" :disabled="isRandomPassword === '1'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-button type="primary" @click="onResetPasswordButtonClick">{{ $t('apply') }}</el-button>
            <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/User/ResetPassword.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import UserApi from '@/api/user-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import { STATUS } from '@/configs/constant'

export default {
  name: 'ResetPassword',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  props: {
    user: {
      type: Object,
      default: function () {
        return {
          id: '',
          companyId: '',
          username: '',
          firstName: '',
          lastName: '',
          email: '',
          isEnable: STATUS.ENABLE
        }
      }
    }
  },
  created: function () {
    this.isLoading = true

    if (this.user.id === undefined || this.user.id === '') {
      this.$router.push({
        name: 'UserList'
      })
    }

    this.isLoading = false
  },
  data () {
    return {
      isLoading: true,
      isRandomPassword: '0',
      newPassword: ''
    }
  },
  methods: {
    onResetPasswordButtonClick: async function () {
      if (!this._validateData(this.isRandomPassword, this.newPassword)) {
        return false
      }

      try {
        this.startLoading()

        await UserApi.resetPassword(this.user.id, this.isRandomPassword, this.newPassword)

        const notificationTitle = this.$t('resetPasswordSuccess')
        this.showNotificationSuccess(notificationTitle)
        this.$router.push({
          name: 'UserList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    _validateData: function (isRandomPassword, newPassword) {
      let message

      if (isRandomPassword === '0') {
        if (newPassword === '') {
          message = this.$t('pleaseEnterNewPassword')
          this.alertError(message)

          return false
        }
      }

      return true
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'UserList'
      })
    }
  }
}

</script>

<style>
  .el-col {
    text-align: left;
  }
</style>
